import { render, staticRenderFns } from "./recordItem.vue?vue&type=template&id=51b45039&scoped=true"
import script from "./recordItem.vue?vue&type=script&lang=js"
export * from "./recordItem.vue?vue&type=script&lang=js"
import style0 from "./recordItem.vue?vue&type=style&index=0&id=51b45039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b45039",
  null
  
)

export default component.exports